import React from 'react';
import Spinner from '../../Icons/Spinner.jsx';
import styles from './Loader.module.css';

/**
 * @param {Object} props
 * @param {boolean} [props.showLoader=false] - Shows the overlay and spinner; when false the overlay stays mounted but hidden
 * @param {string} [props.color='#fff'] - Spinner color
 * @param {number} [props.size=70] - Spinner diameter in px
 * @param {string} [props.className] - Extra class applied to the overlay wrapper
 */
const Loader = ({ showLoader = false, color = '#fff', size = 70, className = '' }) => (
  <div className={[styles.overlay, !showLoader && styles.hide, className].filter(Boolean).join(' ')}>
    <Spinner size={size} color={color} />
  </div>
);

export default Loader;
